<template>
  <div v-if="debug">
    <btn id="debug" type="danger">
      <span class="glyphicon glyphicon-wrench" aria-hidden="true"></span>
      Debug
    </btn>
    <popover target="#debug">
      <template slot="popover">
        <div class="text-center">
          <div>
            <strong>Générateur</strong>
            <p>
              <btn-group>
                <btn v-model="generate" input-type="radio"
                     input-value="seq" :type="generate === 'seq' ? 'success' : 'default'">
                  Séquentiel
                </btn>
                <btn v-model="generate" input-type="radio"
                     input-value="rand" :type="generate === 'rand' ? 'success' : 'default'">
                  Aléatoire
                </btn>
              </btn-group>
            </p>
          </div>
          <div>
            <strong>Nombre de fiches</strong>
            <p>
              <btn-group>
                <btn v-model="count" input-type="radio"
                     input-value="1"
                     :type="count === '1' ? 'success' : 'default'">
                  1
                </btn>
                <btn v-model="count" input-type="radio"
                     input-value="5"
                     :type="count === '5' ? 'success' : 'default'">
                  5
                </btn>
                <btn v-model="count" input-type="radio"
                     input-value="10"
                     :type="count === '10' ? 'success' : 'default'">
                  10
                </btn>
                <btn v-model="count" input-type="radio"
                     input-value="50"
                     :type="count === '50' ? 'success' : 'default'">
                  50
                </btn>
              </btn-group>
            </p>
          </div>
          <div>
            <p>
              <btn @click="fill" type="warning" block>
                Générer
              </btn>
            </p>
            <hr>
            <p>
              <btn @click="clean" type="info" block>
                Remettre à zéro
              </btn>
            </p>
          </div>
        </div>
      </template>
    </popover>
  </div>
</template>
<script>
import save from '@/sui/components/sheet/add/impl/save'
import rand from '@/sui/tools/rand'
import assert from '@/sui/tools/assert'

import moment from 'moment'

function randomDate (start, end) {
  return moment(
    new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()))
  ).format('DD/MM/YYYY')
}

function nextFill (vm, getters, data) {
  const g = getters[vm.step.type]
  if (g == null) {
    return { e: null, goToNextStep: true }
  }

  return { e: g(vm, data), goToNextStep: true }
}

function ktInsertion (vm, f) {
  let ep = vm.cursor.target[f]

  if (ep != null) {
    const epm = moment(ep, 'DD/MM/YYYY')
    const fr = moment(epm).subtract(rand.getInt(1, 10), 'days')
    const result = randomDate(
      fr.toDate(),
      epm.toDate()
    )
    return result
  }

  return null
}

function ktRemoval (vm, f) {
  const ins = vm.cursor.target[f]
  if (ins == null) {
    return null
  }

  const insm = moment(ins, 'DD/MM/YYYY')
  const pmd = vm.cursor.target.previousManipDate

  if (pmd == null) {
    return randomDate(
      insm.toDate(),
      moment(insm).add(rand.getInt(1, 20), 'days').toDate()
    )
  }

  const pmdm = moment(pmd, 'DD/MM/YYYY')
  return randomDate(
    pmdm.toDate(),
    moment(pmdm).add(rand.getInt(1, 20), 'days').toDate()
  )
}

function infEpisod (vm) {
  const y = parseInt(vm.year)
  return randomDate(
    new Date(y, 0, 5),
    new Date(y, 2, 20)
  )
}

function diagDate (vm, fs) {
  let ep = null
  for (let i = 0; i !== fs.length && ep == null; ++i) {
    const f = fs[i]
    ep = vm.cursor.target[f]
  }

  return moment(ep, 'DD/MM/YYYY').add(2, 'days').format('DD/MM/YYYY')
}

function previousManipDate (vm, ins) {
  let ep = null
  const fs = ['episod', 'colIlcBlc']
  for (let i = 0; i !== fs.length && ep == null; ++i) {
    const f = fs[i]
    ep = vm.cursor.target[f]
  }

  const pmd = moment(ep, 'DD/MM/YYYY').subtract(
    rand.getInt(1, 7), 'days'
  )

  const rm = vm.cursor.target.removal
  if (rm != null) {
    return moment.min(
      [
        pmd,
        moment(rm, 'DD/MM/YYYY')
      ]
    ).format('DD/MM/YYYY')
  }

  const insv = vm.cursor.target[ins]
  return moment.max([
    pmd,
    moment(insv, 'DD/MM/YYYY')
  ]).format('DD/MM/YYYY')
}

const dateGetters = {
  analysisDate: (vm) => {
    const y = parseInt(vm.year)

    return randomDate(
      new Date(y, 2, 21),
      new Date(y, 5, 30)
    )
  },

  birthdate: (vm) => {
    const y = parseInt(vm.year)
    let ser = vm.cursor.target.unitType
    ser = ser == null ? vm.cursor.target.sepunitType : ser

    if (ser != null && ser.match(/NEO|MIX/) != null) {
      return randomDate(
        new Date(y - 1, 6, 1),
        new Date(y, 0, 1)
      )
    }

    if (ser != null && ser.match(/PED/) != null) {
      return randomDate(
        new Date(y - 16, 0, 1),
        new Date(y, 0, 1)
      )
    }

    return randomDate(
      new Date(1950, 0, 1),
      new Date(y, 0, 1)
    )
  },

  death: (vm) => {
    const y = parseInt(vm.year)
    return randomDate(
      new Date(y, 11, 1),
      new Date(y, 11, 31)
    )
  },

  entry: (vm) => {
    const y = parseInt(vm.year)
    return randomDate(
      new Date(y, 0, 1),
      new Date(y, 0, 5)
    )
  },

  firstUse: (vm) => {
    const y = parseInt(vm.year)
    const b = moment(vm.sheet.birthdate, 'DD/MM/YYYY')
    const result = randomDate(
      b.toDate(),
      new Date(y, 1, 20)
    )
    return result
  },

  useEnding: (vm) => {
    const b = moment.max(
      [
        moment(vm.cursor.target.firstUse, 'DD/MM/YYYY'),
        moment(vm.sheet.entry, 'DD/MM/YYYY')
      ]
    )
    const e = moment(vm.sheet.exit, 'DD/MM/YYYY')
    return randomDate(
      b.toDate(),
      e.toDate()
    )
  },

  ablation: (vm) => {
    const b = moment.max(
      [
        moment(vm.cursor.target.firstUse, 'DD/MM/YYYY'),
        moment(vm.sheet.entry, 'DD/MM/YYYY')
      ]
    )
    const e = moment(vm.sheet.exit, 'DD/MM/YYYY')
    return randomDate(
      b.toDate(),
      e.toDate()
    )
  },

  firstSubstn: (vm) => {
    const y = parseInt(vm.year)
    const b = moment(vm.cursor.target.birthdate, 'DD/MM/YYYY')
    const result = randomDate(
      b.toDate(),
      new Date(y, 0, 20)
    )
    return result
  },

  date: (vm) => {
    return infEpisod(vm)
  },

  episod: (vm) => {
    return infEpisod(vm)
  },

  pneuepisod: (vm) => {
    return infEpisod(vm)
  },

  sepepisod: (vm) => {
    return infEpisod(vm)
  },

  diagDate: (vm) => {
    return diagDate(
      vm,
      ['episod', 'date', 'colIlcBlc', 'colIlcBlcSep']
    )
  },

  pneudiagDate: (vm) => {
    return diagDate(vm, ['pneuepisod'])
  },

  sepdiagDate: (vm) => {
    return diagDate(vm, ['sepepisod'])
  },

  exit: (vm) => {
    const y = parseInt(vm.year)
    return `01/04/${y}`
  },

  insertionDate: (vm) => {
    return ktInsertion(vm, 'episod')
  },

  catheterInsertion: (vm) => {
    return ktInsertion(vm, 'episod')
  },

  enfPreviousManipDate: (vm) => {
    return previousManipDate(vm, 'catheterInsertion')
  },

  sepinsertion: (vm) => {
    return ktInsertion(vm, 'sepepisod')
  },

  sepremoval: (vm) => {
    return ktRemoval(vm, 'sepinsertion')
  },

  sepenfInsertion: (vm) => {
    return ktInsertion(vm, 'sepepisod')
  },

  sepenfRemoval: (vm) => {
    return ktRemoval(vm, 'sepenfInsertion')
  },

  insertion: (vm) => {
    const ins = ktInsertion(vm, 'episod')
    if (ins != null) {
      return ins
    }

    const y = parseInt(vm.year)
    const b = moment(vm.sheet.birthdate, 'DD/MM/YYYY')
    const result = randomDate(
      b.toDate(),
      new Date(y, 2, 20)
    )
    return result
  },

  removal: (vm) => {
    if (vm.stack.length < 2) {
      return ktRemoval(vm, 'insertion')
    }

    const st = vm.stack[vm.stack.length - 2]
    const fi = st.steps[st.index].field

    if (fi !== 'catheters') {
      return ktRemoval(vm, 'insertion')
    }

    const b = moment.max(
      [
        moment(vm.cursor.target.insertion, 'DD/MM/YYYY'),
        moment(vm.sheet.entry, 'DD/MM/YYYY')
      ]
    )
    let d = vm.sheet.exit
    d = d == null ? vm.sheet.death : d
    let e = moment(d, 'DD/MM/YYYY')
    return randomDate(b.toDate(), e.toDate())
  },

  colIlcBlcSep: (vm) => {
    const b = moment.max(
      [
        moment(vm.cursor.target.insertion, 'DD/MM/YYYY'),
        moment(vm.sheet.entry, 'DD/MM/YYYY')
      ]
    )

    const rm = vm.cursor.target.removal
    if (rm != null) {
      return randomDate(
        b.toDate(), moment(rm, 'DD/MM/YYYY').add(3, 'days').toDate()
      )
    }

    const fs = [vm.sheet.exit, vm.sheet.death]
    let end = null
    for (let i = 0; i !== fs.length && end == null; ++i) {
      end = fs[i]
    }
    const e = moment(end, 'DD/MM/YYYY')
    return randomDate(b.toDate(), e.toDate())
  },

  colIlcBlc: (vm) => {
    const b = moment.max(
      [
        moment(vm.cursor.target.insertion, 'DD/MM/YYYY'),
        moment(vm.sheet.entry, 'DD/MM/YYYY')
      ]
    )

    const rm = vm.cursor.target.removal
    if (rm != null) {
      return randomDate(
        b.toDate(), moment(rm, 'DD/MM/YYYY').add(3, 'days').toDate()
      )
    }

    const fs = [vm.sheet.exit, vm.sheet.death]
    let end = null
    for (let i = 0; i !== fs.length && end == null; ++i) {
      end = fs[i]
    }
    const e = moment(end, 'DD/MM/YYYY')
    return randomDate(b.toDate(), e.toDate())
  },

  previousManipDate: (vm) => {
    return previousManipDate(vm, 'insertion')
  }
}

const getters = {
  rand: {
    bool: (vm) => {
      return rand.getInt(0, 1) === 1
    },

    pickList: (vm) => {
      const s = vm.step
      assert.notNull(s)

      const values = s.config.values
      assert.isArray(values)
      const result = {}
      for (let i = 0; i !== values.length; ++i) {
        const key = values[i].code

        const coin = rand.getInt(0, 1)
        result[key] = coin === 1
      }
      return result
    },

    list: (vm) => {
      const s = vm.step
      const target = vm.it ? vm.it.target : null
      assert.notNull(target)

      const v = s.buildContext(target, vm.sheet).values
      if (v.length === 0) {
        return null
      }

      let ignore = null
      if (s.field === 'code' || s.field === 'accessSite' ||
          s.field === 'central' ||
          (s.field === 'type' && vm.sheet.type === 'neoInfADI')) {
        const st = vm.stack[vm.stack.length - 2]
        const fi = st.steps[st.index].field
        const pl = st.target[fi].length
        const coin = rand.getInt(1, pl)

        if (s.field === 'central') {
          return coin === 1 ? 1 : 2
        }

        if (s.field === 'type') {
          return coin === 1 ? rand.getInList(v.slice(1, 3)).code : v[0].code
        }

        const neu = v[0].code
        if (coin > 1) {
          return neu
        }

        ignore = neu
      }

      if ((s.field === 'bactOrigin' || s.field === 'pneuorigin' ||
           s.field === 'patientOrigin') &&
          vm.sheet.unitType.match(/NEO|PED|MIX/) != null) {
        const ign = {
          bactOrigin: 4, seporigin: 4, pneuorigin: 4, patientOrigin: 7 }
        ignore = ign[s.field]
      } else if (s.field === 'seporigin' &&
                 vm.sheet.sepunitType.match(/NEO|PED|MIX/) != null) {
        ignore = 4
      }

      if (s.field === 'type') {
        ignore = 9
      }

      if (s.field === 'removalReason') {
        const dead = vm.sheet.dead
        if (dead !== 1) {
          ignore = 5
        }
      }

      let result = rand.getInList(v).code
      let i = 0
      while (result === ignore) {
        if (i++ === 10) {
          break
        }
        result = rand.getInList(v).code
      }
      return result
    },

    text: (vm, data) => {
      if (vm.step.field === 'uf') {
        return `UF N°${rand.getInt(1, 3)}`
      }

      return ''
    },

    date: (vm, data) => {
      const dValue = dateGetters

      let d = dValue[vm.step.field]
      if (d != null) {
        return d(vm)
      }

      let result = data.date.format('DD/MM/YYYY')
      data.date = data.date.add(1, 'days')
      return result
    },

    numeric: () => {
      return 10
    }
  },

  seq: {
    bool: (vm) => {
      const s = vm.step
      const p = vm.autofill[s.field]

      return p == null ? rand.getInt(0, 1) === 1 : !p
    },

    pickList: (vm) => {
      const s = vm.step
      const p = vm.autofill[s.field]
      const len = s.config.values.length
      if (len === 0) {
        return null
      }

      const v = p == null ? 0 : ((p + 1) % len)
      vm.autofill[s.field] = v

      const result = {}
      for (let i = 0; i !== len; ++i) {
        const key = s.config.values[i].code
        result[key] = i === v
      }
      return result
    },

    list: (vm) => {
      const s = vm.step
      const p = vm.autofill[s.field]
      const len = s.config.values.length
      if (len === 0) {
        return null
      }

      let v = p == null ? 0 : ((p + 1) % len)
      if ((p == null && s.config.values[v].value.match(/Aucun/)) ||
          (s.field === 'type' &&
           s.config.values[v].value.match(/Non connu/))) {
        v = ((v + 1) % len)
      }
      vm.autofill[s.field] = v

      return s.config.values[v].code
    },

    text: (vm) => {
      if (vm.step.field === 'uf') {
        return `UF N°${rand.getInt(1, 3)}`
      }

      return ''
    },

    date: (vm, data) => {
      const dValue = dateGetters

      let d = dValue[vm.step.field]
      if (d != null) {
        return d(vm)
      }

      let result = data.date.format('DD/MM/YYYY')
      data.date = data.date.add(1, 'days')
      return result
    },

    numeric: () => {
      return 10
    }
  }
}

export default {
  name: 'debug-add',

  props: {
    target: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {
      generate: 'rand',
      count: '1',
      current: 0,
      getters: getters,
      data: {}
    }
  },

  computed: {
    debug: function () {
      return process.env.VUE_APP_SPIADI_DEBUG === '1'
    }
  },

  methods: {
    clean: function () {
      this.target.selectFirstStep()
    },

    fill: function () {
      if (this.target.filling) {
        return
      }

      this.target.filling = true
      this.data.date = moment(`01/01/${this.target.year}`)
      this.current = 0

      const vm = this
      setTimeout(() => { vm.next() })
    },

    next: function () {
      if (parseInt(this.count) === this.current) {
        this.target.filling = false
        this.$store.dispatch(
          'sheet/load', {
            s: this.target.surveillance.id,
            t: this.target.type,
            y: this.target.surveillance.year
          }
        )

        return this.$notify(
          {
            type: 'success',
            title: 'Succès !',
            content: `${this.count} fiches générées avec succès.`
          }
        )
      }

      const t = this.target
      const g = this.getters[this.generate]
      while (t.step.field != null) {
        t.commit(nextFill(t, g, this.data), false)
      }
      t.purge()
      ++this.current

      const vm = this
      setTimeout(
        () => {
          if (parseInt(this.count) === 1) {
            vm.next()
          } else {
            vm.save()
          }
        }, 30
      )
    },

    save: function () {
      const s = save.save(this.target.sheet, this.target.surveillance)
      if (s.error != null) {
        this.$notify(
          {
            type: 'danger',
            title: 'Échec lors de la sauvegarde',
            content: s.error
          }
        )
        return
      }

      const vm = this
      this.$store.dispatch(s.event, s.req).then(
        (r) => {
          if (r.data.err == null) {
            vm.target.selectFirstStep()
            setTimeout(
              () => { vm.next() }, 100
            )
          } else {
            vm.$notify(
              {
                type: 'danger',
                title: `Échec lors de l'envoi des fiches`,
                content: r.data.err
              }
            )
          }
        }
      )
    }
  }
}
</script>
